// Global Constants
export const NAME = 'Name';
export const EMPTY_FIELD_ERROR_MESSAGE = '* Select the category';
export const DATE = 'Date';
export const SUBMIT = 'SUBMIT';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const ADMIN_TITLECASE = 'Admin';
export const ADMIN = 'ADMIN';
export const HR = 'HR';
export const EMPLOYEE = 'emp';
export const EMP_UPPERCASE = 'EMP';

export const POINTS_DETAILS = 'Point Details';
export const ADD_POINTS = 'Add Points';
export const DEDUCT_POINTS = 'Deduct Points';
export const DELETE_POINTS = 'Delete Points';
export const EMP = 'Employee';
export const size = {
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl'
};
export const PB_BALANCE_KEY = 'pbBalance';
export const REWARD_POINTS = 'reward_points';
export const ID = 'id';
export const ADD = 'Add';
export const NAME_LOWERCASE = 'name';
export const APPRECIATOR_KEY = 'addedBy';
export const APPRECIATOR_ID_KEY = 'addedById';
export const REWARD_DATE_KEY = 'reward_date';
export const UPDATE = 'SAVE';
export const UPDATE_EMPLOYEE = 'Edit Employee';
export const CATEGORY = 'Category';
export const EDIT = 'Edit';
export const DELETE = 'Delete';
export const TOTAL_APPRECIATIONS = 10;
export const STATUS_CHANGE = 'Status Change';
//  Signin Component
export const SUCCESSFULLY_LOGGED_IN = 'Successfully logged in';

//  Show Point Component
export const SHOW_POINTS_TABLE_CONSTANTS = {
  name: NAME,
  rewardDate: 'Reward Date',
  category: CATEGORY,
  points: 'Points',
  actions: 'Actions',
  deleteText: 'DELETE',
  totalInterviewes: 'TOTAL INTERVIEWS',
  totalPoints: 'TOTAL POINTS',
  scoreBoard: "'s Scoreboard",
  addedBy: 'Added By',
  comment: 'Comment',
  noComment: '-',
  footPrints: "'s Footprints",
  currentRank: 'Current Rank',
  scorecard: "'s Scorecard"
};
export const employeeParticipatedText = name => `${name}'s Footprints: `;

export const NUMBER_OF_ACTIVITIES = 'Number of activities';
//  Reward Table Component
export const rewardTableConstants = {
  employeeID: 'Employee ID',
  name: NAME,
  points: 'Points',
  addPoints: ADD_POINTS,
  pointDetails: POINTS_DETAILS,
  add: ADD,
  view: 'View',
  updateEmployee: 'Update Employee',
  editText: EDIT,
  deleteText: DELETE,
  pbBalance: 'Balance',
  pbDetails: 'Details'
};

export const CategoryTableConstants = {
  categoryDescription: 'Description',
  categoryPoints: 'Points',
  updateCategoryText: 'Update Category',
  editText: EDIT,
  deleteText: DELETE
};

export const DESC = 'desc';
export const ASC = 'asc';
export const NO_DATA_DISPLAY_MESSAGE = 'No data to be displayed';

//  home component
export const ADD_EMPLOYEE = 'Add Employee';
export const ADD_EMPLOYEE_LOWERCASE = 'add_employee';
export const UPDATE_EMPLOYEE_LOWERCASE = 'update_employee';

export const ADD_REWARD_CATEGORY = 'Add Category';
export const ADD_REWARD_CATEGORY_LOWERCASE = 'add_category';
export const UPDATE_REWARD_CATEGORY = 'Edit Category';
export const UPDATE_REWARD_CATEGORY_LOWERCASE = 'update_category';

export const CLEAR_SERACH = 'Clear Search';
export const VIEW = 'view';
export const ADD_LOWERCASE = 'add';
export const DEDUCT_LOWERCASE = 'deduct';
export const DELETE_LOWERCASE = 'delete';
export const ONLINE = 'online';
export const OFFLINE = 'offline';
export const SEARCH_EMPLOYEE = 'Search Employee';
export const SEARCH_CATEGORY = 'Search Category';
export const SEARCH_GENERIC = 'Search';
export const SEARCH_PLACEHOLDER = 'Enter search text';

export const TAB_LABELS = {
  EMPLOYEE: 'Reward Dashboard',
  CATEGORY: 'Reward Categories',
  PIGGY_BANK: 'Appreciation',
  PIGGY_BANK_BALANCE: 'Appreciation Vault',
  PIGGY_BANK_TRANSACTIONS: 'Appreciation Transactions',
  ABOUT_PAGE: 'About',
  REWARD_DASHBOARD: 'Dashboard',
  PROFILE: 'Profile',
  SETTINGS: 'Settings'
};

//  Add Points
export const CATEGORY_TYPE = 'Category Type';
export const SELECT_CATEGORY = 'Select Category';
export const ADD_ANOTHER_CATEGORY = 'Add Another Category';
export const DATE_FIELD_ERROR_MESSAGE = 'You cannot select future dates ';

// Global Notification Message
export const SUCCESSFULLY_DELETED_POINT = 'Successfully deleted points';
export const SUCCESSFULLY_ADDED_POINT = 'Successfully added points';
export const SUCCESSFULLY_DEDUCTED_POINT = 'Successfully deducted points';
export const EMPLOYEE_ADDED_SUCCESSFULLY = 'Employee Added Successfully';
export const EMPLOYEE_UPDATED_SUCCESSFULLY = 'Employee Updated Successfully';
export const EMPLOYEE_DELETED_SUCCESSFULLY = 'Deleted Employee Successfully';
export const CATEGORY_ADDED_SUCCESSFULLY = 'Category Added Successfully';
export const CATEGORY_UPDATED_SUCCESSFULLY = 'Updated Category Successfully';
export const CATEGORY_DELETED_SUCCESSFULLY = 'Deleted Category Successfully';
export const SUCCESSFULLY_REDEEMED_REWARD = 'Reward Redeemed Successfully';

//  Header Component
export const REWARDS = 'Rewards';

//  Add Employee Component
export const FIELD_REQUIRED_MESSAGE = ' * Field is required';
export const DESCRIPTION_CHAR_LIMIT = 100;
export const MAX_LENGTH_ERROR = `Maximum character limit is ${DESCRIPTION_CHAR_LIMIT}`;
export const ENTER_VALID_EMAIL_ADDRESS = '* Enter Valid Email Address';
export const EMPLOYEE_ROLE = 'Employee Role';
export const EMPLOYEE_EMAIL = 'Employee Email';
export const EMPLOYEE_NAME = 'Employee Name';
export const EMPLOYEE_ID = 'Employee ID';
export const VALID_ID_ERROR = 'Special characters are not allowed';

//  Add Category Component
export const CATEGORY_DESCRIPTION = 'Description';
export const CATEGORY_DESCRIPTION_LOWER = 'description';
export const CATEGORY_POINT = 'Point';
export const CATEGORY_POINT_LOWER = 'point';

// Piggy Bank Component Constants
export const APPRECIATION = 'Appreciation';

export const appreciationListConstants = {
  actions: 'Actions',
  appreciationComment: 'Appreciation Comment',
  appreciations: 'Appreciations',
  appreciator: 'Appreciator',
  deleteText: DELETE,
  employeeName: EMPLOYEE_NAME,
  employeeAppreciations: "'s Appreciations",
  points: 'Points',
  rewardDate: 'Reward Date',
  appreciationDate: 'Appreciation Date',
  to: 'To',
  totalAppreciations: 'Total Appreciations',
  id: 'Appreciator ID',
  noComment: '-'
};

export const LS_KEY_AUTH_DATA = 'authData';
export const AUTH_DATA = JSON.parse(localStorage.getItem(LS_KEY_AUTH_DATA));

export const drawerItemList = [
  {
    id: 'reward-dashboard',
    name: TAB_LABELS.REWARD_DASHBOARD
  },
  {
    id: 'profile',
    name: TAB_LABELS.PROFILE
  },
  {
    id: 'categories',
    name: TAB_LABELS.CATEGORY
  },
  // TODO: REMOVE THIS LATER
  // {
  //   id: 'reward',
  //   name: TAB_LABELS.EMPLOYEE
  // },
  {
    id: 'piggy-bank',
    name: TAB_LABELS.PIGGY_BANK,
    children: [
      {
        id: 'piggy-bank-balance',
        name: TAB_LABELS.PIGGY_BANK_BALANCE
      },
      {
        id: 'piggy-bank-transactions',
        name: TAB_LABELS.PIGGY_BANK_TRANSACTIONS
      }
    ]
  },
  {
    id: 'settings',
    name: TAB_LABELS.SETTINGS
  }
];

// badge contants
export const badgeHashMap = new Map([
  [1, { imgPath: '/images/badgeImages/bronze.png', toolTipTitle: 'Bronze Badge' }],
  [2, { imgPath: '/images/badgeImages/platinum.png', toolTipTitle: 'Silver Badge' }],
  [3, { imgPath: '/images/badgeImages/gold.png', toolTipTitle: 'Gold Badge' }]
]);

export const employeeRoleList = ['ADMIN', 'HR', 'EMP'];

export const navBarLinkist = ['products', 'features', 'testomonials', 'support', 'FAQ'];

export const SHOW_CATEGORY_TYPE = {
  ADD: 'add',
  DEDUCT: 'deduct',
  SHOW_ALL: 'show_all'
};

// tenant specific
export const DEFAULT_TENANT = 'coffeebeans';

export const NON_TENANT_PREFIXES = ['qa', 'staging'];

export const FEATURE_FLAGS = {
  BULK_IMPORT: 'bulk-import',
  ADD_NEW_EMPLOYEE: 'add-new-employee',
  NEGATIVE_MARKING: 'negative-marking',
  BASIC_AUTHENTICATION: 'basic-authentication'
};

export const PUBLIC_ROUTES = [
  '/',
  '/login',
  '/signup',
  '/forgot-password',
  '/reset-password',
  '/check-email',
  '/password-change-success',
  '/link-expired',
  '/email-verification'
];

export const LOGIN_EMAIL_VERIFICATION_ERROR = 'Please verify your email before logging in';
